import { Area, AreaChart, ResponsiveContainer, XAxis } from "recharts"

type SimpleAreaChartProps = {
  data: Array<{ agg_date: string; cost: number }>
  color: string
  onClick?: () => void
  xAxisProps?: {
    ticks?: string[]
    tickFormatter?: (value: string) => string
    fontSize?: number
  }
}

export const RechartsAreaChart = ({
  data,
  color,
  onClick,
  xAxisProps,
}: SimpleAreaChartProps) => {
  return (
    <ResponsiveContainer width="100%" height="100%">
      <AreaChart
        data={data}
        onClick={onClick}
        style={{ cursor: onClick ? "pointer" : "default" }}
      >
        <XAxis
          dataKey="agg_date"
          tickLine={false}
          axisLine={false}
          ticks={xAxisProps?.ticks}
          tickFormatter={xAxisProps?.tickFormatter}
          fontSize={xAxisProps?.fontSize || 12}
          height={20}
          interval="preserveStartEnd"
          tick={{ fill: "var(--mantine-color-textPrimary-0)" }}
        />
        <Area
          type="monotone"
          dataKey="cost"
          stroke={color}
          fill={color}
          fillOpacity={0.15}
          strokeWidth={2}
          dot={false}
          activeDot={false}
          isAnimationActive={false}
        />
      </AreaChart>
    </ResponsiveContainer>
  )
}
